import { createContext, useContext, useState, useCallback } from 'react';

// One global "hide my numbers" switch, not one per section — so toggling it
// once on the dashboard also hides amounts on Transacciones, Categorias and
// Análisis without the user having to repeat it everywhere. Context instead
// of prop-drilling because the components that need it (BalanceCard,
// TransactionList, Charts KPI tiles, etc.) live on different pages with no
// single shared parent to pass a prop through short of App.js itself.
const STORAGE_KEY = 'mipisto_amounts_hidden';

const AmountsVisibilityContext = createContext({ hidden: false, toggle: () => {} });

export function AmountsVisibilityProvider({ children }) {
  const [hidden, setHidden] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (_) {
      return false;
    }
  });

  const toggle = useCallback(() => {
    setHidden((prev) => {
      const next = !prev;
      try { localStorage.setItem(STORAGE_KEY, next ? '1' : '0'); } catch (_) { /* private mode etc. */ }
      return next;
    });
  }, []);

  return (
    <AmountsVisibilityContext.Provider value={{ hidden, toggle }}>
      {children}
    </AmountsVisibilityContext.Provider>
  );
}

export function useAmountsVisibility() {
  return useContext(AmountsVisibilityContext);
}
